import React from "react";

// TODO AND NOTE: Re-enable subscription form functionality when backend is ready

// import React, {useState} from "react";
// import { ValidateEmail as validateEmail } from '../../lib/utils';
// import { DisplaySwalAlert } from '../misc/mySwalAlerts';
// import { SendSubs } from '../site/CancelSub';

// Import site logo image
import siteHorizontalLogo from '../../assets/horizontal-sb-ambar-logo.png';

const SubscriptionForm = ({t}) => {
  // const [emailField, setEmailField] = useState('');
  // const [sendButtonDisabled, setSendButtonDisabled] = useState(false);

  return (
    <>
      {/* Load the src/assets/horizontal-sb-ambar-logo.png and plase it at the middle of this container */}
      <div
        className="subscription-form-logo-container"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          width: '100%',
          minHeight: '120px', // fallback for empty columns
        }}
      >
        <img
          src={siteHorizontalLogo}
          alt="Site Logo"
          className="subscription-form-logo"
          style={{
            maxWidth: '100%',
            maxHeight: '80px',
            objectFit: 'contain',
          }}
        />
      </div>
      {/* <h3>{t("footerSubscribeHeaderMessage")}</h3>
      <div className="input-group">
        <input
          onChange={(e) => emailFieldOnChange(e.target, setEmailField)}
          type="text"
          placeholder="Email"
        />
      </div>
      <div className="button-group">
        <button
          onClick={() => subscribeAction(t, emailField, setSendButtonDisabled)}
          disabled={sendButtonDisabled}
          className="subscribe-btn"
        >
          {t("footerSubscribeButtonText")}
        </button>
      </div> */}
    </>
  );
};

// const subscribeAction = (t, email, btnCallback) => {
//   if (!validateEmail(email)) {
//     DisplaySwalAlert({
//       title: t('subscribeEmailError'),
//       type: 'error',
//       confirmation: false,
//       time: '1600',
//       icon: true
//     });
//   } else {
//     btnCallback(true);
//     SendSubs(email, t, btnCallback);
//   }
// };

// const emailFieldOnChange = (input, setEmailField) => {
//   const inputText = input.value;

//   if (validateEmail(inputText)) {
//     setEmailField(inputText);
//   } else {
//     setEmailField('');
//   }
// };

export default SubscriptionForm;
